import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormValidation, HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { SeguridadSalida, Usuario } from '../../modelo';
import { VerificacionObraService } from './../../datos/verificacion-obra.service';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { environment } from 'src/environments/environment';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    //styleUrls: ['../../../assets/css/css/styles.css', '../../../assets/css/css/bootstrap.css']
})
export class LoginComponent implements OnInit {

    public entity: Usuario;
    public user_MensajeError: FormValidation = new FormValidation(null);
    public password_MensajeError: FormValidation = new FormValidation(null);
    public PATH: string = '../assets/images';
    public url: string;
    public mensaje: string = 'Se recomienda el uso de los navegadores Google Chrome, Mozilla, Firefox, Microsoft Edge, Apple Safari. Cualquier otro navegador, puede no responder adecuadamente.'
    public date: Date = new Date();

    /**
     * 
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {
        //this.menu = new MenuComponent(_router);
        this.url = environment.url;
    }

    ngOnInit(): void {
       
        this.entity = <Usuario>{ user: '', password: '' };

        let respuesta: boolean = this.validarNavegador();

        Util.showMessage(this.servicioAlertas, 'Verificación de Obra', this.mensaje, 'warning');
    }

    /**
     * 
     */
    public async autentificar() {

        if (!this.validarFormumlario()) {

            Util.showLoadingMessage(this.spinner, 'Verificando información ...');

            let dato: JsonResponse<SeguridadSalida> = await this.service.Autentificacion(this.entity).toPromise();

            setTimeout(() => {

                Util.hideLoadingMessage();

                if (dato != null && dato.code == 200 && dato.model != null) {

                    let result = dato.model;

                    if (result.Resultado == 'OK') {

                        console.log('result -->> ', result);

                        if (result.Perfil == null || result.Perfil == 'PVAO') {
                            HttpSession.setAttribute('USER_NAME', `${result.NombreUsuario} ${result.ApellidoPaterno} ${result.ApellidoMaterno}`.toUpperCase());
                            HttpSession.setAttribute('USER_VERIFICADOR', `${result.RazonSocial}`.toUpperCase());
                            HttpSession.setAttribute('USER', result);
                            Util.forward(this._router, 'VistaInformacionGeneralComponent');
                        } else {
                            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'El Usuario no cuenta con el perfil valido ...', 'warning');
                        }

                    } else {
                        Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Usuario invalido...', 'warning');
                    }

                } else {

                    Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error en el Servicio de autentificación ...', 'warning');

                    console.error(`---------------------------------------------------------------------------------------------------------------------`);
                    console.error(`Error: `, dato);

                }

            }, 1000);



        }

    }

    /**
    * 
    * 
    */
    public validarFormumlario(): boolean {

        var error = false;

        this.user_MensajeError = new FormValidation(this.entity.user).requered('El Usuario es obligatorio.');

        if (this.user_MensajeError.error) {
            error = true;
        }

        this.password_MensajeError = new FormValidation(this.entity.password).requered('El Password es obligatorio.');

        if (this.password_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string) {

        switch (tipo) {

            case 'user':

                this.user_MensajeError = new FormValidation(this.entity.user).requered('El Usuario es obligatorio.');

                break;

            case 'password':

                this.password_MensajeError = new FormValidation(this.entity.password).requered('El Password es obligatorio.');

                break;
        }
    }

    /**
     * 
     */
    private validarNavegador(): boolean {

        let resultado: boolean = false;
        
        return resultado;

    }

}
